import React from 'react';

interface EmptyStateProps {
    icon: string;
    title: string;
    description: string;
}

const EmptyState: React.FC<EmptyStateProps> = ({ icon, title, description }) => {
    return (
        <div className="flex flex-col items-center justify-center py-10 px-4 text-center bg-gray-50/50 rounded-xl border border-gray-100 border-dashed">
            <div className="w-12 h-12 bg-gray-100 rounded-full flex items-center justify-center mb-3">
                <span className="text-xl text-gray-400">{icon}</span>
            </div>
            <p className="text-sm font-medium text-gray-900 mb-1">{title}</p>
            <p className="text-xs text-gray-500 max-w-[200px]">{description}</p>
        </div>
    );
};

export default EmptyState;
